import { cn } from "@aurem/ui";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

export const PageLayout = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        "flex flex-col flex-grow p-5 sm:px-8 sm:py-6 w-full",
        className,
      )}
    >
      {children}
    </div>
  );
};
